/** @file useTurntable: while View > Turntable is on, turns the camera yaw a little every animation frame. */
import { useEffect } from 'react';
import type { EditorStore } from '../state/editorTypes';

/** Degrees per second of the turntable (one turn in 12 s). */
const TURNTABLE_DEG_PER_SECOND = 30;

/** Follows `shell.turntable`; the viewport applies the store's yaw each frame, so no panel code is involved. */
export function useTurntable(store: EditorStore): void {
  useEffect(() => {
    let frame = 0;
    let last: number | null = null;
    const tick = (now: number): void => {
      const s = store.getState();
      if (s.shell.turntable) {
        if (last !== null) s.setCamera({ yawDeg: (s.camera.yawDeg + ((now - last) / 1000) * TURNTABLE_DEG_PER_SECOND) % 360 });
        last = now;
      } else last = null;
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(frame); };
  }, [store]);
}
